export enum Colors {
  Red = 'rgb(255,0,0)',
  Orange = 'rgb(255,165,0)',
}
